import DocumentRow from './components/DocumentRow';

const DocumentsList = ({ documents }) => {
  return (
    <div className="flex flex-col space-y-2">
      {documents.map((document) => (
        <DocumentRow document={document} key={document.id} />
      ))}
    </div>
  );
};

export default DocumentsList;
